import CacheKeys from '../cache/CacheKeys'
import CacheManager from '../cache/CacheManager'
import LocalStorageKeys from '../cache/LocalStorageKeys'
import sessions from '../apiclient/moebli/sessions'

class SessionHelper {
  constructor(context) {
    this.context = context
    this.className = 'SessionHelper.js'
  }

  getSession() {
    console.log(this.className, 'getSession')

    let session = null
    if (localStorage.getItem(LocalStorageKeys.Session))
      session = JSON.parse(localStorage.getItem(LocalStorageKeys.Session))
    let params = new URLSearchParams(window.location.search)

    if (!session || params.get('appcode') != null) {
      sessions.post(this.context, this.getSessionCallback)
    }
    else {
      this.context.session = session
      if (session.accountId) {
        this.getAccount(session.accountId)
        this.getPermissions(session.accountId, session.userId)
      }
      else {
        this.context.onContextChange(this.context)
      }
      /*
      // add any new parameters
      let cachedTime = localStorage.getItem(LocalStorageKeys.Session + ':CachedTime')
      if (!cachedTime || Date.now()/1000 - cachedTime > 10) {
        // this should be get, not post; need to test when changed to get
        sessions.post(this.context, this.refreshSessionCallback)
      }
      */
    }
  }

  getSessionCallback = (response) => {
    console.log(this.className, 'getSessionCallback');
    if (response.errorList && response.errorList.length > 0) {
      this.context.onUnrecoverableError(response.errorList[0].message)
      return
    }
    localStorage.setItem(LocalStorageKeys.Session, JSON.stringify(response.session))
    localStorage.setItem(LocalStorageKeys.Session + ':CachedTime', Date.now()/1000)
    this.context.session = response.session
    this.context.onContextChange(this.context)
  }

  // add any new parameters
  refreshSessionCallback = (response) => {
    console.log(this.className, 'refreshSessionCallback');
    if (response.errorList && response.errorList.length > 0) {
      this.context.onUnrecoverableError(response.errorList[0].message)
      return
    }
    let oldSession = JSON.parse(localStorage.getItem(LocalStorageKeys.Session))
    // add any new parameters here
    oldSession.appName = response.session.appName
    localStorage.setItem(LocalStorageKeys.Session, JSON.stringify(oldSession))
    localStorage.setItem(LocalStorageKeys.Session + ':CachedTime', Date.now()/1000)
    this.context.session = oldSession
    this.context.onContextChange(this.context)
  }

  getAccount = (accountId) => {
    this.context.busy = true
    this.context.onContextChange(this.context)
    let cacheManager = new CacheManager({
      resource: `/api/accounts/${accountId}`,
      cacheKey: CacheKeys.Account(accountId),
      callback: this.getAccountCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.context)
  }

  getAccountCallback = (response) => {
    console.log(this.className, 'getAccountCallback');
    this.context.account = response.account
    this.context.busy = false
    this.context.onContextChange(this.context)
  }

  getPermissions = (accountId, userId) => {
    this.context.busy = true
    this.context.onContextChange(this.context)
    let cacheManager = new CacheManager({
      resource: `/api/user/accounts/${accountId}/permissions`,
      cacheKey: CacheKeys.Permissions(accountId, userId),
      callback: this.getPermissionsCallback,
      ttlInSecs: 3600
    })
    cacheManager.getObject2(this.context)
  }

  getPermissionsCallback = (response) => {
    this.context.permissions = response.permissionList
    this.context.busy = false
    this.context.onContextChange(this.context)
  }
}

export default SessionHelper
